<template>
  <!-- 这个是项目管理 -->
  <div class="projectManagement">
    <div class="title_box">
      <el-col :span="10">
        <h4>项目管理</h4>
      </el-col>
      <!-- 左边的输入框 -->

      <!-- 搜索区域 -->
      <div class="searchBox">
        <!-- 右侧的按钮 -->
        <div class="buttonBox" @click="additem = true">
          <el-button size="medium" style="background: #258ce8; color: #fff"
            >添加项目</el-button
          >
        </div>
      </div>
    </div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索区域结束 -->
      <!-- 列表区域 -->
      <div class="table_box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-card class="cardd">
                <ul class="lists">
                  <li @click="toxiangqing('/wjjzyqdetail')">
                    <div class="biaoqian">线上<br />会议</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>会议名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>会议时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <h4>会议地点</h4>
                    <p>{{ props.row.id }}</p>
                    <h4>会议平台</h4>
                    <p>{{ props.row.category }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/wjjzyqdetail')">
                    <div class="biaoqian">线下<br />会议</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>会议名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>会议时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <h4>会议地点</h4>
                    <p>{{ props.row.id }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/wjjzyqdetail')">
                    <div class="biaoqian">直播<br />服务</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>直播名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>会议时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <h4>会议地点</h4>
                    <p>{{ props.row.id }}</p>
                    <h4>直播平台</h4>
                    <p>{{ props.row.id }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/details')">
                    <div class="biaoqian">设计<br />服务</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>服务名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>创建时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/details')">
                    <div class="biaoqian">医学<br />服务</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>服务名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>创建时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/details')">
                    <div class="biaoqian">媒体<br />服务</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>服务名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>创建时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/wjjzyqdetail')">
                    <div class="biaoqian">外籍<br />讲着</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>会议名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>会议时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <h4>会议地点</h4>
                    <p>{{ props.row.shop }}</p>
                    <h4>会议平台</h4>
                    <p>{{ props.row.shop }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                  <li @click="toxiangqing('/software')">
                    <div class="biaoqian">软件<br />开发</div>
                    <div class="iconfont icon-shanchu1 icons"></div>
                    <h4>项目名称</h4>
                    <p>{{ props.row.name }}</p>
                    <h4>创建时间</h4>
                    <p>{{ props.row.shop }}</p>
                    <el-button type="primary" size="small" class="editor"
                      >编辑</el-button
                    >
                  </li>
                </ul>
              </el-card>
            </template>
          </el-table-column>
          <el-table-column label="项目名称" prop="id"> </el-table-column>
          <el-table-column label="创建时间" prop="name"> </el-table-column>
          <el-table-column label="完善项目" prop="desc">
            <template>
              <span
                @click="editoritem = true"
                style="color: #41ab1b; font-size: 15px"
                class="iconfont icon-bianji"
              ></span>
            </template>
          </el-table-column>
          <el-table-column label="删除" prop="desc">
            <template>
              <span
                @click="dialogVisible = true"
                style="color: #f12937; font-size: 15px"
                class="iconfont icon-shanchu"
              ></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 列表区域结束 -->
    </el-card>
    <!-- 这里边是一个分页 -->
    <div class="page">
      <el-pagination background layout="prev, pager, next" :total="1000">
      </el-pagination>
    </div>
    <!-- 气泡对话框 -->
    <!-- :before-close="handleClose" -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="515px">
      <div class="popup">
        <span>确认删除本项目信息吗？</span>
        <div class="buttons">
          <el-button @click="cansol">取消</el-button>
          <el-button>确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="additem" width="515px">
      <div class="popup">
        <div class="itemName">
          项目名称：<el-input
            v-model="inputbox"
            placeholder="请输入项目名称"
          ></el-input>
        </div>
        <div class="buttons">
          <el-button @click="cansol">取消</el-button>
          <el-button>确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择服务类型" :visible.sync="editoritem" width="600px">
      <div class="popup">
        <ul class="editors">
          <li
            v-for="item in lists"
            :key="item.name"
            @click="checkeditor(item.path)"
          >
            <img :src="item.icon" alt="" />
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { lists } from '../../utils/classfiy'
export default {
  name: 'home',
  data () {
    return {
      input1: '',
      lists,
      inputbox: '',
      tableData: [{
        id: '12987122',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987123',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987125',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987126',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }],
      // 是否弹出对话框
      dialogVisible: false,
      additem: false,
      editoritem: false
    }
  },
  methods: {
    // 编辑项目
    handleEdit (index, row) {
      console.log(index, row)
      this.$router.push('/editorProject')
    },
    // 删除项目
    handleDelete (index, row) {
      console.log(index, row)
      // 点击删除以后,先弹出提示框
      this.dialogVisible = true
    },
    // 查看项目
    examine () {
      this.$router.push('/')
    },
    // 进入到项目的主页
    ProjectHome () {
      this.$router.push('/homeProject')
    },
    // 取消删除
    cansol () {
      this.dialogVisible = false
    },
    // 跳转到详情
    checkeditor (path) {
      this.$router.push(path)
    },
    // 跳转到每一项的详情
    toxiangqing (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang='less' scoped>
.projectManagement {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
    .inputBox {
      flex: 1;
      .el-select {
        margin-right: 24px;
      }
      // .el-input {
      //   width: 30%;
      //   margin-right: 24px;
      // }
      .setDateTitle {
        margin-right: 14px;
        color: #8588ae;
        font-size: 18px;
      }
    }
  }
  .el-card {
    flex: 1;
    overflow-y: auto;
    .iconstyle {
      font-size: 20px;
      display: inline-block;
      width: 36px;
      height: 36px;
      border: 1px solid #f1f1f1;
      text-align: center;
      line-height: 36px;
    }
    .lookat {
      color: #121fcf;
    }
    .edtor {
      color: #41ab1b;
    }
    .delete {
      color: #f12937;
    }
  }
  .page {
    text-align: right;
    margin-top: 24px;
  }
  .popup {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    background: url("../../assets/image/cloud.png") no-repeat 0 0 / contain;
    font-size: 18px;
    color: #212529;
    .buttons {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 87px;
      .el-button:nth-child(1) {
        background: #6c757d;
        color: #fff;
      }
      .el-button:nth-child(2) {
        background: #258ce8;
        color: #fff;
      }
    }
  }
  .el-table {
    margin-bottom: 20px;
    &::before {
      height: 0;
    }
    /deep/ tbody {
      tr {
        .el-table__cell {
          border: 0 none;
        }
      }
    }
  }
  .table_box {
    .el-card {
      margin: 0 20px;
      .lists {
        padding: 42px 35px;
        display: flex;
        flex-wrap: wrap;
        li {
          width: 31.1%;
          margin-right: 3.33333%;
          overflow: hidden;
          margin-bottom: 20px;
          box-shadow: 0px 3px 6px #99a4ec;
          border-radius: 8px;
          padding: 25px;
          padding-bottom: 100px;
          position: relative;
          .biaoqian {
            width: 77px;
            height: 77px;
            border-radius: 50%;
            position: absolute;
            top: -17px;
            left: -13px;
            background: #121fcf;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            padding-top: 10px;
            padding-left: 10px;
          }
          .icons {
            float: right;
            cursor: pointer;
          }
          &:nth-child(3n) {
            margin-right: 0%;
          }
          h4 {
            margin-top: 58px;
            font-size: 13px;
            color: #212529;
          }
          p {
            color: #212529;
            font-size: 13px;
            margin-top: 20px;
          }
          .editor {
            margin-top: 18px;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 30px;
          }
        }
      }
    }
  }
  .itemName {
    font-size: 18px;
    color: #212529;
    display: flex;
    align-items: center;
    .el-input {
      flex: 1;
    }
  }
  .editors {
    width: 100%;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 190px;
      height: 55px;
      box-shadow: 0px 5px 12px #bfc2df;
      border-radius: 8px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 10px;
      }
    }
  }
}
</style>
